export const linkedInProfileOpener = {
  open: async (profile) => {
    let id = profile.entityId ? profile.entityId : profile.publicIdentifier

    window.open(`https://www.linkedin.com/in/${id}/`, '_blank')
  }
}
